import React from 'react'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import {
  OfferPackageOptionView,
  getCheapestSelectedPackageOption,
  getCheapestAvailablePackageOption,
  arePricesLoading,
  getFromDurationLabel,
} from 'selectors/offerPage/offerPageSelectors'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import WalledContent from 'components/Common/WalledContent'

import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import Group from 'components/utils/Group'
import OfferPageStickyFooter from '../OfferPageStickyFooter'
import { getHotelOfferDisplayedValue } from 'lib/offer/getOfferDisplayPricing'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'

interface Props {
  offer: App.HotelOffer;
  onViewPackageOptions: () => void;
  cheapestSelectedOption?: OfferPackageOptionView;
  cheapestOption: OfferPackageOptionView;
  calendarsLoading?: boolean;
  durationLabel: string;
}

function AlwaysOnAndLMEOfferPageStickyFooter(props: Props) {
  const {
    offer,
    onViewPackageOptions,
    cheapestOption,
    cheapestSelectedOption,
    calendarsLoading,
    durationLabel,
  } = props

  const dispatch = useOfferPageDispatch()

  const onViewOptionsClick = () => {
    dispatch({ type: OfferPageActions.closeFilter })
    onViewPackageOptions()
  }

  const packageView = cheapestSelectedOption ?? cheapestOption
  const hotelPrice = packageView.hotelTotal
  const { shouldShowValue, shouldShowDiscountPercent, highestDiscountPercent } = getHotelOfferDisplayedValue(!!offer.bundledWithFlightsOnly, hotelPrice, cheapestOption.hotelValue, !!offer.shouldDisplayValue)

  return (
    <OfferPageStickyFooter
      visible
      callToActionCopy="View options"
      onCTAClick={onViewOptionsClick}
      offer={offer}
    >
      <WalledContent enforced={offer.walledGarden}>
        <Group direction="vertical">
          <PriceRowPriceCaption>{durationLabel}</PriceRowPriceCaption>
          <PriceRowPrice
            size="S"
            price={packageView.hotelTotal}
            saleUnit={offer.saleUnit}
          />
          {shouldShowValue && shouldShowDiscountPercent && <PriceRowValueDiscountWithCaption
            size="M"
            originalValue={cheapestOption.hotelValue}
            discountPercentage={highestDiscountPercent}
          />}
          <LoadingIndicator visible={calendarsLoading} floating opaque />
        </Group>
      </WalledContent>
    </OfferPageStickyFooter>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  cheapestSelectedOption: getCheapestSelectedPackageOption(appState, state),
  cheapestOption: getCheapestAvailablePackageOption(state, appState),
  calendarsLoading: arePricesLoading(appState, state),
  durationLabel: getFromDurationLabel(state, appState),
}), AlwaysOnAndLMEOfferPageStickyFooter)
